import React, { useEffect, useState } from "react";
import { Tag } from "../../../compilers/tag";
import Collapse from "../../collapse/Collapse";
import CollapseItem from "../../collapse/CollapseItem";
import "../../../stylesheet/components/catalogue/dropdown/FilterDropdown.scss";
import { LocalisedTag } from "../../../compilers/LocalisedTag";
import CollapseItemToggle from "../../collapse/CollapseItemToggle";
import { useTranslation } from "react-i18next";
import { Category } from "../../../compilers/category";
import { LearningPathway } from "../../../compilers/learningPathway";
import { LocalisedLearningPathway } from "../../../compilers/LocalisedLearningPathway";

type FilterDropdownProps = {
  allTags: Tag[];
  activeTagFilters: Tag[];
  allCategories: Category[];
  addActiveTag: (tag: Tag | LearningPathway) => void;
  addPriceFilter?: (price: string) => void;
  activePriceFilters?: string[];
  addExperienceLevelFilter: (type: string) => void;
  activeExperienceLevelFilter: string[];
  allLearningPathways: LearningPathway[];
  addLearningPathwayFilter: (type: Tag | LearningPathway) => void;
  activeLearningPathwaysFilters: (Tag | LearningPathway)[];
  addTypeFilter: (type: string) => void;
  activeTypeFilters: string[];
  addSourceFilter: (type: string) => void;
  activeSourceFilters: string[];
  section_type: string;
};

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  allTags = [],
  activeTagFilters = [],
  allCategories,
  addActiveTag,
  // addPriceFilter,
  // activePriceFilters,
  addExperienceLevelFilter,
  activeExperienceLevelFilter,
  allLearningPathways,
  addLearningPathwayFilter,
  activeLearningPathwaysFilters,
  addTypeFilter,
  activeTypeFilters,
  addSourceFilter,
  activeSourceFilters,
  section_type,
}) => {
  const [categories, setCategories] = useState<Category[]>([]);
  //console.log(addPriceFilter, activePriceFilters);
  const { ready, t, i18n } = useTranslation();

  useEffect(() => {
    if (categories.length <= 1) {
      setCategories(allCategories);
    }
  }, []);

  if (!categories) {
    return <div>loading..</div>;
  }

  const getLocalisedTagString = (tag: Tag, language_code = "en") => {
    const localised_tag = tag.data.localised_data.find(
      (item: LocalisedTag) => item.language === language_code
    );
    if (localised_tag) {
      return localised_tag.title;
    }
    return;
  };

  const getLocalisedLearningPathwayString = (
    learningPathway: LearningPathway,
    language_code = "en"
  ) => {
    const localised_lp = learningPathway.data.localised_data.find(
      (item: LocalisedLearningPathway) => item.language === language_code
    );
    if (localised_lp) {
      return localised_lp.title;
    }
    return;
  };

  const getLearningPathwayFilters = () =>
    allLearningPathways.map((learningPathway: LearningPathway) => {
      const isActive = activeLearningPathwaysFilters.includes(learningPathway);
      if (getLocalisedLearningPathwayString(learningPathway, i18n.language)) {
        return (
          <CollapseItem
            key={learningPathway.id}
            title={getLocalisedLearningPathwayString(
              learningPathway,
              i18n.language
            )}
            handleClick={addLearningPathwayFilter}
            dataObject={learningPathway}
            isActive={isActive}
          />
        );
      }
    });

  const getSourceFilterItems = () => {
    const language_code: string = i18n.language;
    const localised_source_types: string[] = [];
    if (localised_source_types.length <= 0) {
      categories.forEach((category: Category) => {
        const localised_category = category.data.localised_data.find(
          (item) => item.language === language_code
        );
        if (localised_category) {
          localised_source_types.push(localised_category.text);
        }
      });
    }
    return localised_source_types.map((sourceName: string) => (
      <CollapseItemToggle
        key={sourceName}
        title={sourceName}
        handleClick={addSourceFilter}
        isActive={activeSourceFilters.includes(sourceName)}
      />
    ));
  };

  const getExperienceLevelItems = () => {
    const language_code: string = i18n.language;
    let localised_experience_level = ["Beginner", "Intermediate", "Expert"];
    switch (language_code) {
      case "en":
        break;
      case "ar":
        localised_experience_level = ["مبتدئ", "متوسط", "خبير"];
    }
    return localised_experience_level.map((typeName: string) => {
      return (
        <CollapseItemToggle
          key={typeName}
          title={typeName}
          handleClick={addExperienceLevelFilter}
          isActive={activeExperienceLevelFilter.includes(typeName)}
        />
      );
    });
  };

  // const getPriceItems = () => {
  //   const language_code: string = i18n.language;
  //   let localised_price = ["Free", "Paid"];
  //   switch (language_code) {
  //     case "en":
  //       break;
  //     case "ar":
  //       localised_price = ["مجانا", "دفع"];
  //   }
  //   return localised_price.map((price: string) => {
  //     return (
  //       <CollapseItemToggle
  //         key={price}
  //         title={price}
  //         handleClick={addPriceFilter}
  //         isActive={activePriceFilters.includes(price)}
  //       />
  //     );
  //   });
  // };

  const getTypeFilterItems = () => {
    const language_code: string = i18n.language;
    let localised_cafe_types = ["Article", "Video", "Podcast"];
    switch (language_code) {
      case "en":
        break;
      case "ar":
        localised_cafe_types = ["مقالات", "فيديو", "صوتي"];
    }
    let localised_academy_types = ["Course", "Mini Course"];
    switch (language_code) {
      case "en":
        break;
      case "ar":
        localised_academy_types = ["درس", "كورس"];
    }
    switch (section_type) {
      case "cafe":
        return localised_cafe_types.map((typeName: string) => {
          return (
            <CollapseItemToggle
              key={typeName}
              title={typeName}
              handleClick={addTypeFilter}
              isActive={activeTypeFilters.includes(typeName)}
            />
          );
        });
      case "academy":
        return localised_academy_types.map((typeName: string) => {
          return (
            <CollapseItemToggle
              key={typeName}
              title={typeName}
              handleClick={addTypeFilter}
              isActive={activeTypeFilters.includes(typeName)}
            />
          );
        });
    }
  };

  const getSectionSpecificFilters = () => {
    switch (section_type) {
      case "academy":
        return getAcademySpecificFilters();
      case "cafe":
        return getCafeSpecificFilters();
    }
  };

  const getAcademySpecificFilters = () => {
    return [
      <Collapse
        key="lp"
        title={ready ? t("catalogue-filter.learning-pathways") : ""}
      >
        {getLearningPathwayFilters()}
      </Collapse>,
      <Collapse
        key="xp"
        title={ready ? t("catalogue-filter.experience-level") : ""}
      >
        {getExperienceLevelItems()}
      </Collapse>,
      // <Collapse key="price" title="Price">
      // 	{getPriceItems()}
      // </Collapse>,
      <Collapse
        key="course-type"
        title={ready ? t("catalogue-filter.course-type") : ""}
      >
        {getTypeFilterItems()}
      </Collapse>,
    ];
  };

  const getCafeSpecificFilters = () => {
    return [
      <Collapse key="type" title={ready ? t("catalogue-filter.type") : ""}>
        {" "}
        {getTypeFilterItems()}
      </Collapse>,
      <Collapse
        key="source"
        title={ready ? t("catalogue-filter.category") : ""}
      >
        {getSourceFilterItems()}
      </Collapse>,
    ];
  };

  const getTagFilters = () =>
    allTags.map((tag: Tag) => {
      const isActive = activeTagFilters.includes(tag);
      if (getLocalisedTagString(tag, i18n.language)) {
        return (
          <CollapseItem
            key={tag.id}
            title={getLocalisedTagString(tag, i18n.language)}
            handleClick={addActiveTag}
            dataObject={tag}
            isActive={isActive}
          />
        );
      }
    });

  return (
    <div className="border-top border-2 mt-1n5">
      {getSectionSpecificFilters()}
      <Collapse title={ready ? t("catalogue-filter.tags") : ""}>
        {getTagFilters()}
      </Collapse>
    </div>
  );
};

export default FilterDropdown;
